import React, { useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import NotFoundPage from './pages/errors/NotFoundPage';
import Loading from './Loading';
import { I18nContext } from 'utils/I18n/context';

function CheckContent({ loading: pLoading, isEmpty: pIsEmpty, children }) {
    const { t } = useContext(I18nContext) || {};
    const staticNames = useMemo(() => (t?.errorPage?.notFoundContent), [t]);
    const [loading, setLoading] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);

    useEffect(() => { setLoading(pLoading); setIsEmpty(pIsEmpty); }, [pLoading, pIsEmpty]);

    if (isEmpty && !loading) {
        return <NotFoundPage showCode={false} static={staticNames} />;
    }
    if (loading) {
        return <Loading center={true} />;
    }
    return children;
}

CheckContent.propTypes = { loading: PropTypes.bool, isEmpty: PropTypes.bool, children: PropTypes.node };
export default CheckContent;
